module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.878ad71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/roboto/Roboto-Regular.woff
// module id = 1K5R
// module chunks = 0